import { SORT_BY_FACET } from '@/features/shared/constants/global'
import { AllFiltersOption } from '@/features/shop/components/ProductFilter/FilterOptions/AllFiltersOption'
import { FilterOptions } from '@/features/shop/components/ProductFilter/FilterOptions'
import { FacetOptionsList } from '@/features/shop/components/ProductFilter/FilterOptions/FacetOptionsList'
import { type Facet, SearchType } from '@/features/shop/services/Search/types'
import { FiltersContextProvider } from '@/features/shop/components/ProductFilter/FiltersContext'

type Props = {
  className?: string
  facets: Facet[]
  searchType: SearchType
}

export const SearchFilterOptions = ({
  className,
  facets = [],
  searchType = SearchType.SEARCH,
}: Props) => (
  <FiltersContextProvider facets={facets} searchType={searchType}>
    <FilterOptions className={className}>
      <AllFiltersOption />
      <FacetOptionsList facets={[SORT_BY_FACET, ...facets]} startIndex={1} />
    </FilterOptions>
  </FiltersContextProvider>
)
